/* jshint node:true */
'use strict';

var React = require('react');
var ResponsiveImage = require('../../common/ResponsiveImage.jsx');

var NewsList = React.createClass({

    displayName: 'NewsList',

    render: function () {

        var aArticles       = this.props.articles || [];
        var sLeagueTitle    = this.props.header || '';
        var iNewsLen        = aArticles.length;
        var aNewsRows       = [];
        var newsListView    = null;

        for(var i = 0, len = aArticles.length; i < len; i++){
            var article = aArticles[i];
            var href = article && article.links && article.links.web && article.links.web.href;
            aNewsRows.push(
                <li className="text-container" key={i}>
                    <ResponsiveImage url={href} image={article.images[0]} />
                    <div className="text-container">
                        <h2><a href={href}>{article.headline}</a></h2>
                        <p>{article.description}</p>
                    </div>
                </li>
            );
        }

        var rFooter = null;
        if(typeof this.props.link !== 'undefined' && this.props.link !== null && typeof this.props.link.href !== 'undefined'){
            rFooter = (
                <footer>
                    <a href={this.props.link.href ? this.props.link.href : "#"}>{this.props.link.text}</a>
                </footer>
            );
        }

        if(aNewsRows.length){
            newsListView = (
                <aside className="sub-module sub-module-news">
                    <header className="section-header">
                        <h2>{sLeagueTitle}</h2>
                    </header>
                    <ul className="content">
                        {aNewsRows.length ? aNewsRows : <div><p>No news items</p></div>}
                    </ul>
                    {rFooter}
                </aside>
            );
        }

        return newsListView;
    }
});

module.exports = NewsList;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/NewsList.jsx
 **/